<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fa fa-plug"></i> Módulos</h3>
      </div>
    </div>
    <ModulesList ref="ModuloList" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ModulesList from './components/list/modulesList.vue'

export default {
  name: 'Modules',
  mixins: [ActionsForm],
  data () {
    return {
    }
  },
  components: {
    ModulesList
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
.crm-modules {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/modules/modules.vue